/**
 * Turning an engine's per-word confidence into "does a human need to listen to
 * this?". Field data from a far-from-the-mic speaker: misheard words scored
 * 0.05-0.5, correctly heard ones sat near 1.0 (median 0.98). 0.6 is the
 * "worth a check" line and 0.3 the "probably wrong" one.
 */

export type ConfidenceLevel = 'ok' | 'low' | 'verylow' | 'unknown';

/** A provider that reports no confidence (Zoom) yields 'unknown', not 'low'. */
export function classifyWordConfidence(p: number | null): ConfidenceLevel {
  if (p === null) return 'unknown';
  if (p < 0.3) return 'verylow';
  if (p < 0.6) return 'low';
  return 'ok';
}

export function needsCheck(confidence: number | null): boolean {
  return confidence !== null && confidence < 0.6;
}

export function countLinesToCheck(segments: { confidence: number | null }[]): number {
  return segments.filter((s) => needsCheck(s.confidence)).length;
}
